import * as React from 'react';
export var MenuContext = React.createContext({
    closeMenu: function () { return undefined; },
    closeOnSelect: false,
    open: null,
});
export var MenuTriggerContext = React.createContext({
    caretDirectionClosed: 'down',
    menuId: '',
    open: null,
    setTriggerId: function () { return undefined; },
    showCaret: false,
});
